(function () {
  'use strict';

  function initInfiniteScroll() {
    const grid = document.querySelector('#product-grid');
    const productList = grid ? grid.querySelector('ul.product-grid') : null;

    if (!grid || !productList) {
      console.log('Styled by Chris: productgrid niet gevonden.');
      return;
    }

    const pagination = grid.querySelector('.pagination-wrapper');

    if (!pagination) {
      console.log('Styled by Chris: pagination niet gevonden.');
      return;
    }

    let nextLink = pagination.querySelector('a[rel="next"]');

    if (!nextLink) {
      nextLink = pagination.querySelector('a.pagination__item--next');
    }

    if (!nextLink) {
      nextLink = pagination.querySelector('a.pagination__item--prev');
    }

    if (!nextLink) {
      console.log('Styled by Chris: volgende pagina niet gevonden.');
      return;
    }

    pagination.style.display = 'none';

    let trigger = grid.querySelector('.styled-by-chris-infinite-trigger');

    if (!trigger) {
      trigger = document.createElement('div');
      trigger.className = 'styled-by-chris-infinite-trigger';
      trigger.style.height = '1px';
      trigger.style.width = '100%';
      pagination.parentNode.insertBefore(trigger, pagination);
    }

    let loading = false;
    let finished = false;

    function loadNextPage() {
      if (loading || finished || !nextLink) return;

      loading = true;

      const url = new URL(nextLink.href, window.location.origin);
      const sectionId = grid.dataset.id;

      if (sectionId) {
        url.searchParams.set('section_id', sectionId);
      }

      fetch(url.toString(), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newGrid = doc.querySelector('#product-grid');

          if (!newGrid) {
            finished = true;
            return;
          }

          const products = newGrid.querySelectorAll('ul.product-grid > li.grid__item');

          if (!products.length) {
            finished = true;
            return;
          }

          products.forEach(function (product) {
            productList.appendChild(product);
          });

          const newPagination = newGrid.querySelector('.pagination-wrapper');

          if (!newPagination) {
            finished = true;
            return;
          }

          let newNextLink = newPagination.querySelector('a[rel="next"]');

          if (!newNextLink) {
            newNextLink = newPagination.querySelector('a.pagination__item--next');
          }

          if (!newNextLink) {
            newNextLink = newPagination.querySelector('a.pagination__item--prev');
          }

          if (!newNextLink) {
            finished = true;
            return;
          }

          nextLink = newNextLink;
        })
        .catch(function (error) {
          console.error('Styled by Chris infinite scroll error:', error);
        })
        .finally(function () {
          loading = false;
          checkScroll();
        });
    }

    function checkScroll() {
      if (loading || finished) return;

      const scrollPosition = window.innerHeight + window.scrollY;
      const pageHeight = document.documentElement.scrollHeight;

      if (scrollPosition >= pageHeight - 1200) {
        loadNextPage();
      }
    }

    window.addEventListener('scroll', checkScroll, { passive: true });
    checkScroll();

    console.log('Styled by Chris infinite scroll actief');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInfiniteScroll);
  } else {
    initInfiniteScroll();
  }
})();